import MENU_ITEMS from './menu-items'

function hasOwnerRole (roleList) {
  return roleList.includes('OWNER')
}

function getAllowedMenuFilter (roleList) {
  const hasRole = role => roleList.includes(role)
  return item => !item.rolesAllowed || item.rolesAllowed.some(hasRole)
}

function filterAllowedMenu (menuList, roleList) {
  return menuList
    .filter(getAllowedMenuFilter(roleList))
    .map(({ children, ...menu }) => ({
      ...menu,
      ...(children ? { children: filterAllowedMenu(children, roleList) } : {}),
    }))
}

function getTranslateMapper (i18n) {
  return function translateMenu ({ title, children, ...menu }) {
    return {
      ...menu,
      ...(children ? { children: children.map(translateMenu) } : {}),
      title: i18n.t(title),
    }
  }
}

function getMenuList (roleList, { i18n } = {}) {
  const menuList = hasOwnerRole(roleList)
    ? MENU_ITEMS
    : filterAllowedMenu(MENU_ITEMS, roleList)

  return i18n
    ? menuList.map(getTranslateMapper(i18n))
    : menuList
}

function flattenChildren (list) {
  return list.reduce((acc, item) => ([...acc, item, ...flattenChildren(item.children || [])]), [])
}

function getShortcutList (name, roleList, { i18n } = {}) {
  const menuList = getMenuList(roleList, { i18n })
  return flattenChildren(menuList)
    .filter(item => item.shortcut?.[name])
}

export default {
  getMenuList,
  getShortcutList,
}
